import React, { useState, useContext, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthContext from '../../context/auth/authContext';
import MultiSelectDropdown from '../shared/MultiSelectDropdown';
import { GAME_OPTIONS } from '../../config/gameOptions';
import '../../styles/auth.css';

const Register = () => {
  const authContext = useContext(AuthContext);
  const { register, error, clearErrors, isAuthenticated } = authContext;
  const navigate = useNavigate();

  const [user, setUser] = useState({
    username: '',
    email: '',
    password: '',
    password2: ''
  });

  // Store selected games as an array of values
  const [selectedGames, setSelectedGames] = useState(['tcg', 'vgc']);

  const { username, email, password, password2 } = user;

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }

    if (error) {
      toast.error(error);
      clearErrors();
    }
  }, [error, isAuthenticated, navigate, clearErrors]);

  const onChange = e => setUser({ ...user, [e.target.name]: e.target.value });

  const handleGameSelection = (selectedValues) => {
    // The MultiSelectDropdown already ensures minimum selections
    setSelectedGames(selectedValues);
  };

  const onSubmit = e => {
    e.preventDefault();
    if (password !== password2) {
      toast.error('Passwords do not match');
    } else if (selectedGames.length === 0) {
      toast.error('Please select at least one game mode');
    } else {
      // Convert selected games array to preferences object
      const gamePreferences = {};
      GAME_OPTIONS.forEach(option => {
        gamePreferences[option.value] = selectedGames.includes(option.value);
      });

      register({
        username,
        email,
        password,
        gamePreferences
      });
    }
  };

  return (
    <div className="auth-page page-narrow">
      <div className="auth-card">
        <div className="form-container">
          <div className="auth-logo">
            <img
              src="/Logo-with-slogan.png"
              alt="PokeMatch Logo"
              style={{ maxWidth: '300px', width: '100%', marginBottom: '20px' }}
            />
          </div>
          <h1>
            Account <span className="text-primary">Register</span>
          </h1>
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                name="username"
                className="form-control"
                value={username}
                onChange={onChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={email}
                onChange={onChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                value={password}
                onChange={onChange}
                required
                minLength="6"
              />
            </div>
            <div className="form-group">
              <label htmlFor="password2">Confirm Password</label>
              <input
                type="password"
                name="password2"
                className="form-control"
                value={password2}
                onChange={onChange}
                required
                minLength="6"
              />
            </div>
            
            <MultiSelectDropdown
              options={GAME_OPTIONS}
              selectedValues={selectedGames}
              onChange={handleGameSelection}
              placeholder="Select game modes..."
              minSelections={1}
              label="Game Preferences"
              required={true}
            />
            <small style={{ 
              color: '#666', 
              marginTop: '-10px', 
              marginBottom: '15px', 
              display: 'block',
              fontSize: '12px'
            }}>
              Select which game modes you want to track. You can change this later in settings.
            </small>
            
            <input type="submit" value="Register" className="btn btn-primary btn-block" />
          </form>
          <div className="auth-links">
            <p>Already have an account? <Link to="/login">Login</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
